// @ts-nocheck
import { getWarrantyBySerialAndModel } from "@store/Framework/Services/Pages/ProductWarrantyLookup/ProductWarrantyLookupService";
import { WarrantyResult } from "@store/Framework/Types/ApiModels";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

type GetWarrantyBySerialAndModelParameter = {
    serialNumber: string;
    modelNumber: string;
};

type HandlerType = ApiHandler<GetWarrantyBySerialAndModelParameter, WarrantyResult>;

export const DispatchBeginWarrantyLookupData: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/ProductCatalogs/BeginWarrantyLookupData",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getWarrantyBySerialAndModel(props.parameter.serialNumber, props.parameter.modelNumber);
};

export const DispatchCompleteSetWarranty: HandlerType = props => {
    const { dispatch, apiResult } = props;

    switch (apiResult.type) {
        case 0:
            dispatch({
                type: "Store/Pages/ProductWarrantyLookup/SetModels",
                response: apiResult,
            });
            break;
        case 1:
            dispatch({
                type: "Store/Pages/ProductWarrantyLookup/SetWarranty",
                response: apiResult,
            });
            break;
        default:
            dispatch({
                type: "Store/Pages/ProductWarrantyLookup/SetWarranty",
                response: apiResult,
            });
    }
};

export const chain = [DispatchBeginWarrantyLookupData, RequestDataFromApi, DispatchCompleteSetWarranty];

const findWarrantyBySerialAndModel = createHandlerChainRunner(chain, "FindWarrantyBySerialAndModel");
export default findWarrantyBySerialAndModel;
